import React from 'react';
import { LogOut, X, AlertCircle } from 'lucide-react';

const LogoutConfirmationModal = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full transform transition-all animate-scale-in">
        {/* Header with gradient */}
        <div className="bg-gradient-to-br from-red-500 via-orange-500 to-pink-500 p-6 rounded-t-3xl relative overflow-hidden">
          <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
          <button
            onClick={onCancel}
            className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors"
          >
            <X size={24} />
          </button>
          
          <div className="flex flex-col items-center text-center relative z-10">
            <div className="bg-white/20 backdrop-blur-md rounded-full p-4 mb-4 animate-bounce-slow">
              <LogOut size={40} className="text-white" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-2">
              Leaving Already?
            </h2>
            <p className="text-white/90 text-sm">
              We'll miss you! Come back soon for fresh milk delivery.
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="bg-orange-50 border border-orange-200 rounded-xl p-4 mb-6 flex items-start gap-3">
            <AlertCircle size={20} className="text-orange-600 flex-shrink-0 mt-0.5" />
            <div className="text-sm text-orange-800">
              <p className="font-medium mb-1">Before you go...</p>
              <p className="text-orange-700">Your cart items and preferences will be saved for your next visit.</p>
            </div>
          </div>

          {/* Action buttons */}
          <div className="flex gap-3">
            <button
              onClick={onCancel}
              className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-800 font-semibold py-3.5 rounded-xl transition-all duration-200 hover:scale-105"
            >
              Stay Logged In
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600 text-white font-semibold py-3.5 rounded-xl transition-all duration-200 hover:scale-105 shadow-lg hover:shadow-xl"
            >
              Yes, Logout
            </button>
          </div>
        </div>

        {/* Footer note */}
        <div className="px-6 pb-6">
          <p className="text-center text-xs text-gray-500">
            You can sign back in anytime to continue shopping
          </p>
        </div>
      </div>

      <style>{`
        @keyframes scale-in {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        @keyframes bounce-slow {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        
        .animate-scale-in {
          animation: scale-in 0.3s ease-out;
        }
        
        .animate-bounce-slow {
          animation: bounce-slow 2s ease-in-out infinite;
        }
        
        .bg-grid-pattern {
          background-image: 
            linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px);
          background-size: 20px 20px;
        }
      `}</style>
    </div>
  );
};

export default LogoutConfirmationModal;
